import axios from "axios";

const tripBalanceApiClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
    headers: { "Content-Type": "application/json" }
});

export const getTripBalances = (year) => tripBalanceApiClient.get("/finance/trip-balance", { params: { year } });
